import { cn } from "@workspace/frontend-ui";
import { cva } from "class-variance-authority";
import type { CSSProperties, FC, PropsWithChildren } from "react";
import { TILE_COLOR } from "../palette";
import type { TileType } from "../types";

type Props = PropsWithChildren<{
  type: TileType;
  size: "28" | "34" | "40";
  className?: string;
}>;

const tileVariants = cva(
  "relative grid shrink-0 place-items-center bg-[linear-gradient(157.56deg,rgb(255_255_255/0.2)_11.5%,rgb(255_255_255/0.04)_46.9%,rgb(0_0_0/0.1)_88.5%),linear-gradient(var(--tile),var(--tile))] shadow-[0_2px_6px_-2px_rgb(0_0_0/0.35),inset_0_-1px_0_rgb(0_0_0/0.22),inset_0_1px_0_rgb(255_255_255/0.26)] [&>svg]:drop-shadow-[0_0.6px_0.3px_rgb(0_0_0/0.25)]",
  {
    variants: {
      size: {
        "28": "size-7 rounded-lg [&>*]:size-4.5",
        "34": "size-8.5 rounded-lg [&>*]:size-5.5",
        "40": "size-10 rounded-xl [&>*]:size-6",
      },
    },
  },
);

const Tile: FC<Props> = ({ type, size, className, children }) => (
  <span
    data-slot="tile"
    data-type={type}
    className={cn(tileVariants({ size }), className)}
    style={{ "--tile": TILE_COLOR[type] } as CSSProperties}
  >
    {children}
  </span>
);

export default Tile;
